import AirlineRankingTable from "./AirlineRankingTable";

export default AirlineRankingTable;
